import { render } from "./StepCustomer.vue?vue&type=template&id=464a5eff"
import script from "./StepCustomer.vue?vue&type=script&lang=js"
export * from "./StepCustomer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__